import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import DraftTemplates from './DraftTemplates';
import { StyledTab, StyledTabs } from './index.styles';
import PublishedTemplates from './PublishedTemplates';
import { TabsPanel } from './TemplatesTabsPanel';

enum TemplatesTab {
    Published,
    Draft
}

const TemplatesTable: React.FC = () => {
    const { t } = useTranslation('templates');
    const [value, setValue] = useState(TemplatesTab.Published);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <>
            <StyledTabs onChange={handleChange} value={value}>
                <StyledTab label={t('published-public')} />
                <StyledTab label={t('drafts-private')} />
            </StyledTabs>
            <TabsPanel index={0} value={value}>
                <PublishedTemplates />
            </TabsPanel>
            <TabsPanel index={1} value={value}>
                <DraftTemplates />
            </TabsPanel>
        </>
    );
};

export default TemplatesTable;
